<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <!-- <div class="vx-col" v-if = "!isUpdate">
            <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="addNewRecord(0)"/>
          </div> -->
          <div v-for="(permission, index) in permissions" :key="permission.id" class = "mt-3 vx-row">
            <div class="vx-col md:w-1/6 w-full mt-2">
              <vs-input
                v-validate="'required|min:3'"
                :data-vv-name="'functionName' + index"
                :data-vv-as="'Tên chức năng'"
                data-vv-validate-on="blur"
                type="account"
                name="functionName"
                :label="$t('permission.action')"
                v-model="permission.functionName"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("functionName" + index)
              }}</span>
            </div>
            <div class="vx-col md:w-1/6 w-full mt-2">
              <vs-input
                v-validate="'required|min:3'"
                :data-vv-name="'functionAlias' + index"
                data-vv-validate-on="blur"
                :data-vv-as="'Tên hiển thị'"
                type="account"
                name="functionAlias"
                :label="$t('permission.displayName')"
                v-model="permission.functionAlias"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("functionAlias" + index)
              }}</span>
            </div>
            <div class="vx-col md:w-1/6 w-full mt-2">
              <vs-input
                v-validate="'required|min:3'"
                :data-vv-name="'functionApiPrefix' + index"
                data-vv-validate-on="blur"
                :data-vv-as="'Api Path'"
                type="account"
                name="functionApiPrefix"
                label="Api Path"
                v-model="permission.functionApiPrefix"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("functionApiPrefix" + index)
              }}</span>
            </div>
            <div class="vx-col md:w-1/6 w-full mt-2">
              <vs-input
                v-validate="'required|min:3'"
                :data-vv-name="'functionScreenPrefix' + index"
                data-vv-validate-on="blur"
                :data-vv-as="'Screen Path'"
                type="account"
                name="functionScreenPrefix"
                label="Screen Path"
                v-model="permission.functionScreenPrefix"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("functionScreenPrefix" + index)
              }}</span>
            </div>
            <div class="vx-col md:w-1/6 w-full mt-2">
              <vs-input class="w-full" :label="$t('permission.displayName')" v-model="permission.metadata"
                      name="metadata" type="number" />
              <span class="text-danger text-sm">{{ errors.first('metadata') }}</span>
            </div>
            <div class="vx-col" style="padding-top: 30px">
                  <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" v-if = "!isUpdate"  @click="addNewRecord(index + 1)"/>
              </div>
            <div class="vx-col" style="padding-top: 30px">
                <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" v-if = "!isUpdate" @click="confirmDeleteRecord(index)"/>
            </div>
          </div>
          <!-- <div class = "vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-textarea class="w-full" label="Thông tin bổ sung" v-model="permission.metadata"
                      name="metadata"/>
              <span class="text-danger text-sm">{{ errors.first('metadata') }}</span>
            </div>
          </div> -->

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm || permissions.length == 0">{{`${isUpdate ?
                  $t('permission.update'): $t('permission.create')}`}}
                </vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">{{$t('permission.back')}}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>

</template>
<script>

  import vSelect from 'vue-select'
  export default {
    data() {
      return {
        isUpdate: false,
        id: null,
        permissions: [{}],
      };
    },
    components: {
      vSelect,
    },
    computed: {
      validateForm() {
        return !this.errors.any();
      },
    },
    created() {
      this.permissionId = this.$route.query.id;
      if (this.permissionId) {
        this.$vs.loading();
        this.$business.post('/permission/find-by-id/' + this.permissionId).then((response) => {
          this.$vs.loading.close();
          this.permissions = [response.data];
          this.isUpdate = true;
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
    },
    methods: {
      async saveChanges(evt) {
        evt.preventDefault();
        if (!this.validateForm) return;

        const result = await this.$validator.validateAll();
        if (!result) return;
        let path = this.isUpdate ? ('/permission/update/' + this.permissionId ) : '/permission/create';
        let params = this.isUpdate ? this.permissions[0] : this.permissions;
        this.$vs.loading();
        this.$business.post(path, params).then(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: 'primary',
            text: `${this.isUpdate ? this.$t('permission.update') : this.$t('permission.add')}` + this.$t('permission.textUpdate'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          this.$router.push('/admin/manage-permission').catch(() => {
          })
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      },
      addNewRecord(index) {
        this.permissions.splice(index, 0, {})
      },
      confirmDeleteRecord(index) {
        this.index = index;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('permission.titleDelete'),
          text: this.$t('permission.textDelete2'),
          accept: this.deleteRecord,
          acceptText: this.$t('permission.acceptText'),
          cancelText: this.$t('permission.cancelText')
        })
      },
      deleteRecord() {
        this.permissions.splice(this.index, 1)
      }
    }
  };
</script>
